export const MXLockerLogoSmall = ({
  fill = 'black',
  className,
}: {
  fill: string;
  className?: string;
}) => (
  <svg
    width="50"
    height="32"
    viewBox="0 0 50 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.57742 0L1 22.9779L6.60376 22.9995L13.0082 0H7.57742Z"
      fill={fill}
    />
    <path
      d="M22.1126 0.0216328L15.7515 7.01019L13.5445 0L11.0996 8.22183L12.9603 16.422L19.7542 8.24347L22.1126 0.0216328Z"
      fill={fill}
    />
    <path
      d="M21.5746 23.0407L28.1087 0.041164L22.4833 0.0195312L15.9707 23.019L21.5746 23.0407Z"
      fill={fill}
    />
    <path
      d="M34.0401 23.0641L40.4012 23.0857L37.5452 10.8612L46.4595 0.0862426H41.1153L36.3336 5.94972L34.9921 0.0646098L28.6743 0.0429688L31.3572 11.5535L14.1562 31.9783L19.587 31.9999L32.5257 16.7463L34.0401 23.0641Z"
      fill={fill}
    />
    <path
      d="M27.7184 24.3633H26.7664L25.2734 29.6642H28.7137L28.9083 28.8853L26.4419 28.842L27.7184 24.3633Z"
      fill={fill}
    />
    <path
      d="M31.9599 28.4327L31.5273 28.8006H30.3155L30.0559 28.476L30.8564 25.5767L31.2891 25.2522H32.4575L32.7605 25.5767L31.9599 28.4327ZM33.15 24.3867H31.1377L30.0343 25.1873L29.0391 28.8438L29.7097 29.7309H31.6353L32.7821 28.8222L33.799 25.2305L33.15 24.3867Z"
      fill={fill}
    />
    <path
      d="M36.0915 27.7187L35.8969 28.5193L35.4858 28.8222H34.3823L34.1227 28.4111L34.9232 25.6633L35.3775 25.2738H36.5026L36.6974 25.6416L36.5459 26.2907H37.4979L37.7792 25.1656L37.1517 24.3867H35.2477L34.0577 25.2955L33.0625 28.7573L33.7981 29.7309H35.6372L36.7622 28.8438L37.0435 27.7404L36.0915 27.7187Z"
      fill={fill}
    />
    <path
      d="M42.1976 24.4062H41.1808L38.7575 26.5266L39.3416 24.4062H38.3896L36.875 29.7288L37.8703 29.7504L38.4112 27.8897L39.2984 27.1108L39.796 29.7504H40.748L40.0773 26.3535L42.1976 24.4062Z"
      fill={fill}
    />
    <path
      d="M42.6717 27.3272H44.4458L44.6189 26.5915H42.8447L43.191 25.2933H45.7657L46.0037 24.4279L42.5634 24.4062L41.0273 29.7504H44.5108L44.7487 28.8634H42.239L42.6717 27.3272Z"
      fill={fill}
    />
    <path
      d="M46.6495 26.7189L47.0388 25.3342H48.4236L48.6399 25.5938L48.4669 26.416L48.0773 26.7622L46.6495 26.7189ZM49.3107 26.7189L49.7001 25.2044L49.1375 24.4688H46.3899L44.8535 29.8129H45.8057L46.4115 27.6493H47.0605L47.4067 29.8129H48.3803L47.991 27.6493H48.2506L49.3107 26.7189Z"
      fill={fill}
    />
  </svg>
);
